import { render, staticRenderFns } from "./SalesChannel.vue?vue&type=template&id=3269ce06&scoped=true&"
import script from "./SalesChannel.vue?vue&type=script&lang=js&"
export * from "./SalesChannel.vue?vue&type=script&lang=js&"
import style0 from "./SalesChannel.vue?vue&type=style&index=0&id=3269ce06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3269ce06",
  null
  
)

export default component.exports